import React from "react";
import Main from "./Main";
import Places from "../../components/Places";
import Newsletter from "../../components/Newsletter";

const YourTrips = () => {
  return (
    <>
      <Main />
      <Newsletter />
    </>
  );
};

export default YourTrips;
